import { render, staticRenderFns } from "./UploadIdentity.vue?vue&type=template&id=b67ab4a4&"
import script from "./UploadIdentity.vue?vue&type=script&lang=js&"
export * from "./UploadIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports